export enum AdjudicationStatus {
  Accepted = 'Accepted',
  PartiallyAccepted = 'Partially Accepted',
  Rejected = 'Rejected',
  Unknown = 'Unknown'
}
